import { Spinner } from '@mm/components';
import React, { FunctionComponent } from 'react';
import { useRouteMatch } from 'react-router';
import { AutomationEdit } from './AutomationEdit';
import { AutomationEditEmailSold } from './AutomationEditEmailSold';
import { useAutomation } from './use-automation';

export const AutomationEditRouter: FunctionComponent = () => {
  const match = useRouteMatch<{ id?: string; chatbotId: string }>();
  const id = parseInt(match.params.id || '', 10);

  const automationData = useAutomation({
    id,
  });

  if (!automationData.state.automation) {
    return <Spinner standalone size={32} />;
  }
  switch (automationData.state.automation.details?.automationTemplate) {
    case 'email_sold_automation':
      return <AutomationEditEmailSold automationData={automationData} />;
    case 'empty_automation':
    default:
      return <AutomationEdit automationData={automationData} />;
  }
};
